import { FC, useState } from 'react';
import { cn, Skeleton } from '@fe-learner-common';

type CourseImageProps = {
  thumbnail?: string | null;
  height?: number;
  width?: number;
  alt: string;
  className?: string;
  onSettled?: () => void;
};

const appendSize = (url: string, size: number) => {
  const _url = new URL(url);
  _url.searchParams.append('size', size.toString());
  return _url.toString();
};

export const CourseImage: FC<CourseImageProps> = ({
  className,
  thumbnail,
  width,
  alt,
  onSettled,
}) => {
  const [useFallback, setUseFallback] = useState(false);

  if (useFallback || !thumbnail) {
    return <Skeleton type="card" className={cn('w-full', className)} />;
  }

  const src = appendSize(thumbnail, 128);
  const srcset = [
    appendSize(thumbnail, 1024) + ' 1024w',
    appendSize(thumbnail, 512) + ' 512w',
    appendSize(thumbnail, 256) + ' 256w',
    appendSize(thumbnail, 128) + ' 128w',
  ].join(', ');

  const sizes =
    '(max-width: 300px) 100vw, ' +
    '(max-width: 900px) 50vw, ' +
    '(max-width: 1200px) 33vw, ' +
    '(max-width: 1200px) 25vw, ' +
    '360px';

  return (
    <img
      className={cn(
        'aspect-video w-full rounded-xl bg-neutral-100 object-cover',
        `${width && `w-[${width}px]`}`,
        className,
      )}
      onError={() => {
        setUseFallback(true);
        onSettled?.();
      }}
      {...(width && { width: `${width}px` })}
      sizes={sizes}
      srcSet={srcset}
      src={src}
      loading="lazy"
      onLoad={() =>  onSettled?.()}
      alt={alt}
    />
  );
};
